import { render, staticRenderFns } from "./data85.vue?vue&type=template&id=3b7bf1e5&scoped=true"
import script from "./data85.vue?vue&type=script&lang=js"
export * from "./data85.vue?vue&type=script&lang=js"
import style1 from "./data85.vue?vue&type=style&index=1&id=3b7bf1e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7bf1e5",
  null
  
)

export default component.exports